import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette, LARGE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 300px)',
      color: colorsPalette.white,
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 250px)',
      },
      '& h1': {
        color: fade(colorsPalette.white, 0.5),
        [theme.breakpoints.up('md')]: {
          fontSize: 50,
        },
      },
      '& h3': {
        margin: `${LARGE_MARGIN}px 0 ${SMALL_MARGIN}px`,
      },
    },
  }),
);

export default useStyles;
